// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* AppDataFetcher.module.css */

.AppDataFetcher_container__Xe8-S {
  padding: 1.5rem;
  max-width: 72rem;
  margin: 0 auto;
}

.AppDataFetcher_loadingContainer__041io {
  color: #4b5563;
  text-align: center;
}

.AppDataFetcher_loadingText__kJ\\+VK {
  color: #6b7280;
  text-align: center;
  padding: 2rem;
}

.AppDataFetcher_errorMessage__f6eFF {
  margin-bottom: 1rem;
  background-color: #fee2e2;
  border: 1px solid #f87171;
  color: #991b1b;
  padding: 0.75rem 1rem;
  border-radius: 0.375rem;
  position: relative;
  padding-right: 2.5rem;
}

.AppDataFetcher_errorMessage__f6eFF strong {
  font-weight: 600;
}

.AppDataFetcher_closeErrorButton__eU\\+6Y {
  position: absolute;
  right: 0.75rem;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  font-size: 1.25rem;
  cursor: pointer;
  color: #991b1b;
  padding: 0.25rem 0.5rem;
  line-height: 1;
}

.AppDataFetcher_closeErrorButton__eU\\+6Y:hover {
  color: #7f1a1a;
}

.AppDataFetcher_header__KuVuB {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
}

.AppDataFetcher_title__NzMWo {
  font-size: 1.5rem;
  font-weight: 700;
  color: #1f2937;
}

.AppDataFetcher_buttonGroup__RDaB7 {
  display: flex;
  gap: 0.75rem;
}

.AppDataFetcher_buttonPrimary__1NL4b {
  padding: 0.5rem 1rem;
  background-color: #059669;
  color: white;
  border-radius: 0.375rem;
  border: none;
  cursor: pointer;
  font-weight: 500;
  transition: background-color 0.2s;
}

.AppDataFetcher_buttonPrimary__1NL4b:hover:not(:disabled) {
  background-color: #047857;
}

.AppDataFetcher_buttonPrimary__1NL4b:disabled {
  background-color: #9ca3af;
  cursor: not-allowed;
}

.AppDataFetcher_buttonSecondary__zwPbA {
  padding: 0.5rem 1rem;
  background-color: #6b7280;
  color: white;
  border-radius: 0.375rem;
  border: none;
  cursor: pointer;
  font-weight: 500;
  transition: background-color 0.2s;
}

.AppDataFetcher_buttonSecondary__zwPbA:hover:not(:disabled) {
  background-color: #4b5563;
}

.AppDataFetcher_buttonSecondary__zwPbA:disabled {
  background-color: #9ca3af;
  cursor: not-allowed;
}

.AppDataFetcher_buttonOutline__eU8qh {
  padding: 0.5rem 1rem;
  border: 1px solid #d1d5db;
  background-color: white;
  color: #374151;
  border-radius: 0.375rem;
  cursor: pointer;
  font-weight: 500;
  transition: background-color 0.2s;
}

.AppDataFetcher_buttonOutline__eU8qh:hover:not(:disabled) {
  background-color: #f9fafb;
}

.AppDataFetcher_buttonOutline__eU8qh:disabled {
  background-color: #f3f4f6;
  cursor: not-allowed;
  opacity: 0.6;
}

/* Uploader Styles */
.AppDataFetcher_uploader__fpmey {
  margin-bottom: 1.5rem;
  padding: 1rem;
  border: 2px dashed #d1d5db;
  border-radius: 0.5rem;
  background-color: #fafafa;
  animation: AppDataFetcher_slideDown__9aB\\+g 0.3s ease-out;
}

@keyframes AppDataFetcher_slideDown__9aB\\+g {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.AppDataFetcher_uploaderHeader__xxBXm {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.75rem;
}

.AppDataFetcher_uploaderTitle__4wS4g {
  font-size: 1.125rem;
  font-weight: 600;
  color: #1f2937;
  margin: 0;
}

.AppDataFetcher_closeButton__HwlTM {
  background: none;
  border: none;
  font-size: 1.5rem;
  line-height: 1;
  cursor: pointer;
  color: #6b7280;
  padding: 0 0.5rem;
  transition: color 0.2s;
}

.AppDataFetcher_closeButton__HwlTM:hover {
  color: #374151;
}

.AppDataFetcher_uploaderDescription__-olZH {
  font-size: 0.875rem;
  color: #4b5563;
  margin-bottom: 0.75rem;
}

.AppDataFetcher_uploaderHighlight__WSs4I {
  color: #2563eb;
  font-weight: 500;
}

.AppDataFetcher_uploaderActions__t-i2m {
  display: flex;
  gap: 0.75rem;
  margin-bottom: 1rem;
}

.AppDataFetcher_fileInput__aJMI\\+ {
  display: none;
}

.AppDataFetcher_fileLabel__SYDNK {
  display: inline-flex;
  align-items: center;
  padding: 0.5rem 1rem;
  border: 1px solid transparent;
  font-size: 0.875rem;
  font-weight: 500;
  border-radius: 0.375rem;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  color: white;
  background-color: #059669;
  cursor: pointer;
  transition: background-color 0.2s;
}

.AppDataFetcher_fileLabel__SYDNK:hover:not(.AppDataFetcher_fileLabelDisabled__Lxf7T) {
  background-color: #047857;
}

.AppDataFetcher_fileLabelDisabled__Lxf7T {
  background-color: #9ca3af;
  cursor: not-allowed;
}

/* File Preview Styles */
.AppDataFetcher_filePreview__dI02u {
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid #e5e7eb;
  animation: AppDataFetcher_slideDown__9aB\\+g 0.3s ease-out;
}

.AppDataFetcher_fileInfo__QHKkr {
  background-color: #f3f4f6;
  padding: 0.75rem;
  border-radius: 0.375rem;
  margin-bottom: 1rem;
}

.AppDataFetcher_fileName__ECP6j {
  font-size: 0.875rem;
  color: #1f2937;
  margin-bottom: 0.5rem;
  word-break: break-all;
}

.AppDataFetcher_fileStats__0MXAu {
  font-size: 0.875rem;
  color: #4b5563;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.AppDataFetcher_previewUsers__6SjFX {
  font-size: 0.75rem;
  color: #6b7280;
  font-family: monospace;
}

.AppDataFetcher_uploadActions__zwsr7 {
  display: flex;
  gap: 0.75rem;
}

.AppDataFetcher_submitButton__2DjdY {
  flex: 1 1;
  padding: 0.5rem 1rem;
  background-color: #3b82f6;
  color: white;
  border: none;
  border-radius: 0.375rem;
  cursor: pointer;
  font-weight: 500;
  transition: background-color 0.2s;
}

.AppDataFetcher_submitButton__2DjdY:hover:not(:disabled) {
  background-color: #2563eb;
}

.AppDataFetcher_submitButton__2DjdY:disabled {
  background-color: #9ca3af;
  cursor: not-allowed;
}

.AppDataFetcher_clearButton__ghI\\+Y {
  padding: 0.5rem 1rem;
  background-color: #ef4444;
  color: white;
  border: none;
  border-radius: 0.375rem;
  cursor: pointer;
  font-weight: 500;
  transition: background-color 0.2s;
}

.AppDataFetcher_clearButton__ghI\\+Y:hover:not(:disabled) {
  background-color: #dc2626;
}

.AppDataFetcher_clearButton__ghI\\+Y:disabled {
  background-color: #9ca3af;
  cursor: not-allowed;
}

/* Upload Results Styles */
.AppDataFetcher_uploadResultContainer__ol4qM {
  margin-bottom: 1.5rem;
  padding: 1rem;
  background-color: white;
  border: 1px solid #e5e7eb;
  border-radius: 0.5rem;
  animation: AppDataFetcher_slideDown__9aB\\+g 0.3s ease-out;
}

.AppDataFetcher_resultsGrid__manKs {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
  margin-bottom: 1rem;
}

.AppDataFetcher_resultCard__YuRkF {
  padding: 1rem;
  border-radius: 0.5rem;
}

.AppDataFetcher_resultCardSuccess__RA8Rs {
  background-color: #f0fdf4;
}

.AppDataFetcher_resultCardError__oIvyP {
  background-color: #fef2f2;
}

.AppDataFetcher_resultNumber__39dOf {
  font-size: 1.5rem;
  font-weight: 700;
}

.AppDataFetcher_resultNumberSuccess__efm8v {
  color: #059669;
}

.AppDataFetcher_resultNumberError__yz3WG {
  color: #dc2626;
}

.AppDataFetcher_resultLabel__6qjCQ {
  font-size: 0.875rem;
}

.AppDataFetcher_resultLabelSuccess__ds7lf {
  color: #166534;
}

.AppDataFetcher_resultLabelError__SIVxK {
  color: #991b1b;
}

.AppDataFetcher_infoMessage__wM1Ob {
  margin-bottom: 1rem;
  padding: 0.75rem;
  background-color: #eff6ff;
  color: #1e40af;
  border-radius: 0.375rem;
}

.AppDataFetcher_sectionTitle__2vDzp {
  font-weight: 600;
  color: #374151;
  margin-bottom: 0.5rem;
}

.AppDataFetcher_scrollableList__E1Xvt {
  max-height: 10rem;
  overflow-y: auto;
  border: 1px solid #e5e7eb;
  border-radius: 0.375rem;
}

.AppDataFetcher_listContainer__ahLjI {
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: 0.25rem;
  padding: 0.5rem;
}

.AppDataFetcher_listItem__rmgE6 {
  font-size: 0.875rem;
  color: #4b5563;
}

.AppDataFetcher_listItemError__Ayvfa {
  padding: 0.5rem;
  border-bottom: 1px solid #e5e7eb;
}

.AppDataFetcher_listItemError__Ayvfa:last-child {
  border-bottom: none;
}

.AppDataFetcher_errorUid__y\\+LWQ {
  font-size: 0.875rem;
  font-weight: 500;
  color: #dc2626;
}

.AppDataFetcher_errorReason__R97Zc {
  font-size: 0.75rem;
  color: #ef4444;
}

/* Table Styles */
.AppDataFetcher_tableWrapper__0Y9dy {
  overflow-x: auto;
  background-color: white;
  border-radius: 0.5rem;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  overflow: hidden;
}

.AppDataFetcher_userTable__K8wOb {
  min-width: 100%;
  border-collapse: collapse;
}

.AppDataFetcher_tableHeader__Vq0aR {
  background-color: #f9fafb;
}

.AppDataFetcher_tableHeaderCell__tofN\\+ {
  padding: 0.75rem 1.5rem;
  text-align: left;
  font-size: 0.75rem;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #6b7280;
}

.AppDataFetcher_tableRow__F\\+p0A {
  border-bottom: 1px solid #e5e7eb;
}

.AppDataFetcher_tableRow__F\\+p0A:hover {
  background-color: #f9fafb;
}

.AppDataFetcher_tableCell__sfILy {
  padding: 1rem 1.5rem;
  white-space: nowrap;
  font-size: 0.875rem;
  color: #111827;
}

.AppDataFetcher_tableCellSecondary__qFTvW {
  color: #6b7280;
}

/* Badge Styles */
.AppDataFetcher_badge__1Yv\\+g {
  display: inline-flex;
  padding: 0 0.5rem;
  font-size: 0.75rem;
  font-weight: 600;
  line-height: 1.25rem;
  border-radius: 9999px;
}

.AppDataFetcher_badgeSuccess__f8Kn3 {
  background-color: #d1fae5;
  color: #065f46;
}

.AppDataFetcher_badgeError__dryL1 {
  background-color: #fee2e2;
  color: #991b1b;
}

.AppDataFetcher_badgeNeutral__\\+MJCy {
  color: #9ca3af;
}

/* Empty State */
.AppDataFetcher_emptyState__L2dOI {
  background-color: #fef9c3;
  border: 1px solid #facc15;
  color: #854d0e;
  padding: 0.75rem 1rem;
  border-radius: 0.375rem;
}

/* Responsive */
@media (max-width: 768px) {
  .AppDataFetcher_header__KuVuB {
    flex-direction: column;
    gap: 1rem;
    align-items: stretch;
  }
  
  .AppDataFetcher_title__NzMWo {
    text-align: center;
  }
  
  .AppDataFetcher_buttonGroup__RDaB7 {
    justify-content: center;
  }
  
  .AppDataFetcher_uploaderActions__t-i2m {
    flex-direction: column;
  }
  
  .AppDataFetcher_uploadActions__zwsr7 {
    flex-direction: column;
  }
  
  .AppDataFetcher_resultsGrid__manKs {
    grid-template-columns: 1fr;
  }
  
  .AppDataFetcher_tableCell__sfILy {
    padding: 0.75rem 1rem;
  }
}


@media (max-width: 480px) {
  .AppDataFetcher_container__Xe8-S {
    padding: 0px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Component/SideData/Overview/Users/AppDataFetcher.module.css"],"names":[],"mappings":"AAAA,8BAA8B;;AAE9B;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EAEE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,qBAAqB;EACrB,uBAAuB;EACvB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,QAAQ;EACR,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,uBAAuB;EACvB,cAAc;EACd,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;AACd;;AAEA,oBAAoB;AACpB;EACE,qBAAqB;EACrB,aAAa;EACb,0BAA0B;EAC1B,qBAAqB;EACrB,yBAAyB;EACzB,yDAAkC;AACpC;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;EACpB,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,2CAA2C;EAC3C,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,yDAAkC;AACpC;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,SAAO;EACP,oBAAoB;EACpB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;EACE,qBAAqB;EACrB,aAAa;EACb,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;EACrB,yDAAkC;AACpC;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EAEE,yBAAyB;AAC3B;;AAEA;EAEE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EAEE,cAAc;AAChB;;AAEA;EAEE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EAEE,cAAc;AAChB;;AAEA;EAEE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EAEE,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;EACrB,2EAA2E;EAC3E,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EAEE,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EAEE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EAEE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EAEE,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA,eAAe;AACf;EACE;IACE,sBAAsB;IACtB,SAAS;IACT,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,qBAAqB;EACvB;AACF;;;AAGA;EACE;IACE,YAAY;EACd;AACF","sourcesContent":["/* AppDataFetcher.module.css */\n\n.container {\n  padding: 1.5rem;\n  max-width: 72rem;\n  margin: 0 auto;\n}\n\n.loadingContainer {\n  composes: container;\n  color: #4b5563;\n  text-align: center;\n}\n\n.loadingText {\n  color: #6b7280;\n  text-align: center;\n  padding: 2rem;\n}\n\n.errorMessage {\n  margin-bottom: 1rem;\n  background-color: #fee2e2;\n  border: 1px solid #f87171;\n  color: #991b1b;\n  padding: 0.75rem 1rem;\n  border-radius: 0.375rem;\n  position: relative;\n  padding-right: 2.5rem;\n}\n\n.errorMessage strong {\n  font-weight: 600;\n}\n\n.closeErrorButton {\n  position: absolute;\n  right: 0.75rem;\n  top: 50%;\n  transform: translateY(-50%);\n  background: none;\n  border: none;\n  font-size: 1.25rem;\n  cursor: pointer;\n  color: #991b1b;\n  padding: 0.25rem 0.5rem;\n  line-height: 1;\n}\n\n.closeErrorButton:hover {\n  color: #7f1a1a;\n}\n\n.header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1.5rem;\n}\n\n.title {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #1f2937;\n}\n\n.buttonGroup {\n  display: flex;\n  gap: 0.75rem;\n}\n\n.buttonPrimary {\n  padding: 0.5rem 1rem;\n  background-color: #059669;\n  color: white;\n  border-radius: 0.375rem;\n  border: none;\n  cursor: pointer;\n  font-weight: 500;\n  transition: background-color 0.2s;\n}\n\n.buttonPrimary:hover:not(:disabled) {\n  background-color: #047857;\n}\n\n.buttonPrimary:disabled {\n  background-color: #9ca3af;\n  cursor: not-allowed;\n}\n\n.buttonSecondary {\n  padding: 0.5rem 1rem;\n  background-color: #6b7280;\n  color: white;\n  border-radius: 0.375rem;\n  border: none;\n  cursor: pointer;\n  font-weight: 500;\n  transition: background-color 0.2s;\n}\n\n.buttonSecondary:hover:not(:disabled) {\n  background-color: #4b5563;\n}\n\n.buttonSecondary:disabled {\n  background-color: #9ca3af;\n  cursor: not-allowed;\n}\n\n.buttonOutline {\n  padding: 0.5rem 1rem;\n  border: 1px solid #d1d5db;\n  background-color: white;\n  color: #374151;\n  border-radius: 0.375rem;\n  cursor: pointer;\n  font-weight: 500;\n  transition: background-color 0.2s;\n}\n\n.buttonOutline:hover:not(:disabled) {\n  background-color: #f9fafb;\n}\n\n.buttonOutline:disabled {\n  background-color: #f3f4f6;\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n/* Uploader Styles */\n.uploader {\n  margin-bottom: 1.5rem;\n  padding: 1rem;\n  border: 2px dashed #d1d5db;\n  border-radius: 0.5rem;\n  background-color: #fafafa;\n  animation: slideDown 0.3s ease-out;\n}\n\n@keyframes slideDown {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.uploaderHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 0.75rem;\n}\n\n.uploaderTitle {\n  font-size: 1.125rem;\n  font-weight: 600;\n  color: #1f2937;\n  margin: 0;\n}\n\n.closeButton {\n  background: none;\n  border: none;\n  font-size: 1.5rem;\n  line-height: 1;\n  cursor: pointer;\n  color: #6b7280;\n  padding: 0 0.5rem;\n  transition: color 0.2s;\n}\n\n.closeButton:hover {\n  color: #374151;\n}\n\n.uploaderDescription {\n  font-size: 0.875rem;\n  color: #4b5563;\n  margin-bottom: 0.75rem;\n}\n\n.uploaderHighlight {\n  color: #2563eb;\n  font-weight: 500;\n}\n\n.uploaderActions {\n  display: flex;\n  gap: 0.75rem;\n  margin-bottom: 1rem;\n}\n\n.fileInput {\n  display: none;\n}\n\n.fileLabel {\n  display: inline-flex;\n  align-items: center;\n  padding: 0.5rem 1rem;\n  border: 1px solid transparent;\n  font-size: 0.875rem;\n  font-weight: 500;\n  border-radius: 0.375rem;\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  color: white;\n  background-color: #059669;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.fileLabel:hover:not(.fileLabelDisabled) {\n  background-color: #047857;\n}\n\n.fileLabelDisabled {\n  background-color: #9ca3af;\n  cursor: not-allowed;\n}\n\n/* File Preview Styles */\n.filePreview {\n  margin-top: 1rem;\n  padding-top: 1rem;\n  border-top: 1px solid #e5e7eb;\n  animation: slideDown 0.3s ease-out;\n}\n\n.fileInfo {\n  background-color: #f3f4f6;\n  padding: 0.75rem;\n  border-radius: 0.375rem;\n  margin-bottom: 1rem;\n}\n\n.fileName {\n  font-size: 0.875rem;\n  color: #1f2937;\n  margin-bottom: 0.5rem;\n  word-break: break-all;\n}\n\n.fileStats {\n  font-size: 0.875rem;\n  color: #4b5563;\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.previewUsers {\n  font-size: 0.75rem;\n  color: #6b7280;\n  font-family: monospace;\n}\n\n.uploadActions {\n  display: flex;\n  gap: 0.75rem;\n}\n\n.submitButton {\n  flex: 1;\n  padding: 0.5rem 1rem;\n  background-color: #3b82f6;\n  color: white;\n  border: none;\n  border-radius: 0.375rem;\n  cursor: pointer;\n  font-weight: 500;\n  transition: background-color 0.2s;\n}\n\n.submitButton:hover:not(:disabled) {\n  background-color: #2563eb;\n}\n\n.submitButton:disabled {\n  background-color: #9ca3af;\n  cursor: not-allowed;\n}\n\n.clearButton {\n  padding: 0.5rem 1rem;\n  background-color: #ef4444;\n  color: white;\n  border: none;\n  border-radius: 0.375rem;\n  cursor: pointer;\n  font-weight: 500;\n  transition: background-color 0.2s;\n}\n\n.clearButton:hover:not(:disabled) {\n  background-color: #dc2626;\n}\n\n.clearButton:disabled {\n  background-color: #9ca3af;\n  cursor: not-allowed;\n}\n\n/* Upload Results Styles */\n.uploadResultContainer {\n  margin-bottom: 1.5rem;\n  padding: 1rem;\n  background-color: white;\n  border: 1px solid #e5e7eb;\n  border-radius: 0.5rem;\n  animation: slideDown 0.3s ease-out;\n}\n\n.resultsGrid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 1rem;\n  margin-bottom: 1rem;\n}\n\n.resultCard {\n  padding: 1rem;\n  border-radius: 0.5rem;\n}\n\n.resultCardSuccess {\n  composes: resultCard;\n  background-color: #f0fdf4;\n}\n\n.resultCardError {\n  composes: resultCard;\n  background-color: #fef2f2;\n}\n\n.resultNumber {\n  font-size: 1.5rem;\n  font-weight: 700;\n}\n\n.resultNumberSuccess {\n  composes: resultNumber;\n  color: #059669;\n}\n\n.resultNumberError {\n  composes: resultNumber;\n  color: #dc2626;\n}\n\n.resultLabel {\n  font-size: 0.875rem;\n}\n\n.resultLabelSuccess {\n  composes: resultLabel;\n  color: #166534;\n}\n\n.resultLabelError {\n  composes: resultLabel;\n  color: #991b1b;\n}\n\n.infoMessage {\n  margin-bottom: 1rem;\n  padding: 0.75rem;\n  background-color: #eff6ff;\n  color: #1e40af;\n  border-radius: 0.375rem;\n}\n\n.sectionTitle {\n  font-weight: 600;\n  color: #374151;\n  margin-bottom: 0.5rem;\n}\n\n.scrollableList {\n  max-height: 10rem;\n  overflow-y: auto;\n  border: 1px solid #e5e7eb;\n  border-radius: 0.375rem;\n}\n\n.listContainer {\n  display: grid;\n  grid-template-columns: repeat(1, 1fr);\n  gap: 0.25rem;\n  padding: 0.5rem;\n}\n\n.listItem {\n  font-size: 0.875rem;\n  color: #4b5563;\n}\n\n.listItemError {\n  composes: listItem;\n  padding: 0.5rem;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.listItemError:last-child {\n  border-bottom: none;\n}\n\n.errorUid {\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: #dc2626;\n}\n\n.errorReason {\n  font-size: 0.75rem;\n  color: #ef4444;\n}\n\n/* Table Styles */\n.tableWrapper {\n  overflow-x: auto;\n  background-color: white;\n  border-radius: 0.5rem;\n  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);\n  overflow: hidden;\n}\n\n.userTable {\n  min-width: 100%;\n  border-collapse: collapse;\n}\n\n.tableHeader {\n  background-color: #f9fafb;\n}\n\n.tableHeaderCell {\n  padding: 0.75rem 1.5rem;\n  text-align: left;\n  font-size: 0.75rem;\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: #6b7280;\n}\n\n.tableRow {\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.tableRow:hover {\n  background-color: #f9fafb;\n}\n\n.tableCell {\n  padding: 1rem 1.5rem;\n  white-space: nowrap;\n  font-size: 0.875rem;\n  color: #111827;\n}\n\n.tableCellSecondary {\n  composes: tableCell;\n  color: #6b7280;\n}\n\n/* Badge Styles */\n.badge {\n  display: inline-flex;\n  padding: 0 0.5rem;\n  font-size: 0.75rem;\n  font-weight: 600;\n  line-height: 1.25rem;\n  border-radius: 9999px;\n}\n\n.badgeSuccess {\n  composes: badge;\n  background-color: #d1fae5;\n  color: #065f46;\n}\n\n.badgeError {\n  composes: badge;\n  background-color: #fee2e2;\n  color: #991b1b;\n}\n\n.badgeNeutral {\n  composes: badge;\n  color: #9ca3af;\n}\n\n/* Empty State */\n.emptyState {\n  background-color: #fef9c3;\n  border: 1px solid #facc15;\n  color: #854d0e;\n  padding: 0.75rem 1rem;\n  border-radius: 0.375rem;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .header {\n    flex-direction: column;\n    gap: 1rem;\n    align-items: stretch;\n  }\n  \n  .title {\n    text-align: center;\n  }\n  \n  .buttonGroup {\n    justify-content: center;\n  }\n  \n  .uploaderActions {\n    flex-direction: column;\n  }\n  \n  .uploadActions {\n    flex-direction: column;\n  }\n  \n  .resultsGrid {\n    grid-template-columns: 1fr;\n  }\n  \n  .tableCell {\n    padding: 0.75rem 1rem;\n  }\n}\n\n\n@media (max-width: 480px) {\n  .container {\n    padding: 0px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `AppDataFetcher_container__Xe8-S`,
	"loadingContainer": `AppDataFetcher_loadingContainer__041io AppDataFetcher_container__Xe8-S`,
	"loadingText": `AppDataFetcher_loadingText__kJ+VK`,
	"errorMessage": `AppDataFetcher_errorMessage__f6eFF`,
	"closeErrorButton": `AppDataFetcher_closeErrorButton__eU+6Y`,
	"header": `AppDataFetcher_header__KuVuB`,
	"title": `AppDataFetcher_title__NzMWo`,
	"buttonGroup": `AppDataFetcher_buttonGroup__RDaB7`,
	"buttonPrimary": `AppDataFetcher_buttonPrimary__1NL4b`,
	"buttonSecondary": `AppDataFetcher_buttonSecondary__zwPbA`,
	"buttonOutline": `AppDataFetcher_buttonOutline__eU8qh`,
	"uploader": `AppDataFetcher_uploader__fpmey`,
	"slideDown": `AppDataFetcher_slideDown__9aB+g`,
	"uploaderHeader": `AppDataFetcher_uploaderHeader__xxBXm`,
	"uploaderTitle": `AppDataFetcher_uploaderTitle__4wS4g`,
	"closeButton": `AppDataFetcher_closeButton__HwlTM`,
	"uploaderDescription": `AppDataFetcher_uploaderDescription__-olZH`,
	"uploaderHighlight": `AppDataFetcher_uploaderHighlight__WSs4I`,
	"uploaderActions": `AppDataFetcher_uploaderActions__t-i2m`,
	"fileInput": `AppDataFetcher_fileInput__aJMI+`,
	"fileLabel": `AppDataFetcher_fileLabel__SYDNK`,
	"fileLabelDisabled": `AppDataFetcher_fileLabelDisabled__Lxf7T`,
	"filePreview": `AppDataFetcher_filePreview__dI02u`,
	"fileInfo": `AppDataFetcher_fileInfo__QHKkr`,
	"fileName": `AppDataFetcher_fileName__ECP6j`,
	"fileStats": `AppDataFetcher_fileStats__0MXAu`,
	"previewUsers": `AppDataFetcher_previewUsers__6SjFX`,
	"uploadActions": `AppDataFetcher_uploadActions__zwsr7`,
	"submitButton": `AppDataFetcher_submitButton__2DjdY`,
	"clearButton": `AppDataFetcher_clearButton__ghI+Y`,
	"uploadResultContainer": `AppDataFetcher_uploadResultContainer__ol4qM`,
	"resultsGrid": `AppDataFetcher_resultsGrid__manKs`,
	"resultCard": `AppDataFetcher_resultCard__YuRkF`,
	"resultCardSuccess": `AppDataFetcher_resultCardSuccess__RA8Rs AppDataFetcher_resultCard__YuRkF`,
	"resultCardError": `AppDataFetcher_resultCardError__oIvyP AppDataFetcher_resultCard__YuRkF`,
	"resultNumber": `AppDataFetcher_resultNumber__39dOf`,
	"resultNumberSuccess": `AppDataFetcher_resultNumberSuccess__efm8v AppDataFetcher_resultNumber__39dOf`,
	"resultNumberError": `AppDataFetcher_resultNumberError__yz3WG AppDataFetcher_resultNumber__39dOf`,
	"resultLabel": `AppDataFetcher_resultLabel__6qjCQ`,
	"resultLabelSuccess": `AppDataFetcher_resultLabelSuccess__ds7lf AppDataFetcher_resultLabel__6qjCQ`,
	"resultLabelError": `AppDataFetcher_resultLabelError__SIVxK AppDataFetcher_resultLabel__6qjCQ`,
	"infoMessage": `AppDataFetcher_infoMessage__wM1Ob`,
	"sectionTitle": `AppDataFetcher_sectionTitle__2vDzp`,
	"scrollableList": `AppDataFetcher_scrollableList__E1Xvt`,
	"listContainer": `AppDataFetcher_listContainer__ahLjI`,
	"listItem": `AppDataFetcher_listItem__rmgE6`,
	"listItemError": `AppDataFetcher_listItemError__Ayvfa AppDataFetcher_listItem__rmgE6`,
	"errorUid": `AppDataFetcher_errorUid__y+LWQ`,
	"errorReason": `AppDataFetcher_errorReason__R97Zc`,
	"tableWrapper": `AppDataFetcher_tableWrapper__0Y9dy`,
	"userTable": `AppDataFetcher_userTable__K8wOb`,
	"tableHeader": `AppDataFetcher_tableHeader__Vq0aR`,
	"tableHeaderCell": `AppDataFetcher_tableHeaderCell__tofN+`,
	"tableRow": `AppDataFetcher_tableRow__F+p0A`,
	"tableCell": `AppDataFetcher_tableCell__sfILy`,
	"tableCellSecondary": `AppDataFetcher_tableCellSecondary__qFTvW AppDataFetcher_tableCell__sfILy`,
	"badge": `AppDataFetcher_badge__1Yv+g`,
	"badgeSuccess": `AppDataFetcher_badgeSuccess__f8Kn3 AppDataFetcher_badge__1Yv+g`,
	"badgeError": `AppDataFetcher_badgeError__dryL1 AppDataFetcher_badge__1Yv+g`,
	"badgeNeutral": `AppDataFetcher_badgeNeutral__+MJCy AppDataFetcher_badge__1Yv+g`,
	"emptyState": `AppDataFetcher_emptyState__L2dOI`
};
export default ___CSS_LOADER_EXPORT___;
